import { AutoAwesome } from '@mui/icons-material';
import {
    Box,
    Button,
    Container,
    Divider,
    Paper,
    Stack,
    Typography,
} from '@mui/material';

function ComingSoon() {
    return (
        <Box height="100%" display="flex" flexDirection="column" width="100%">
            <Container
                // maxWidth="md"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                    textAlign: 'center',
                    borderRadius: 7,
                    my: 4,
                    backgroundColor: theme => theme.palette.background.default,
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        padding: 6,
                        borderRadius: 4,
                        maxWidth: 600,
                        width: '100%',
                    }}
                >
                    <Stack spacing={4}>
                        <AutoAwesome
                            sx={{
                                fontSize: 60,
                                color: theme => theme.palette.primary.main,
                            }}
                        />
                        <Typography variant="h3" fontWeight="bold">
                            Something Awesome is Coming!
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            We’re hard at work creating a new experience for
                            you. Stay tuned for updates and be ready for the
                            future!
                        </Typography>
                        <Divider sx={{ marginY: 2 }} />
                        <Button
                            variant="contained"
                            size="large"
                            color="primary"
                            sx={{ borderRadius: 3 }}
                            onClick={() => alert('You’ll be notified soon!')}
                        >
                            Notify Me
                        </Button>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}

export default ComingSoon;
